import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { ItfEcoCartItem } from '../../type';
import { ItfEcoCartFooter } from './type';
import getLocal from 'eco-design-reliance/getLocal';
import './index.scss';
import EcoCartFooterCoupon from '../EcoCartFooterCoupon';
import { useEffect, useState } from 'react';
import useEcoCart from '../../useEcoCart';
import { i18n } from '../../i18n';
import EcoLink from 'eco-design/base/eco-link';
import { handle_GTM_31 } from 'eco-design-micro/gtmEvent/31';
import { ItfGTM31Cust } from 'eco-design-micro/gtmEvent/31/type';

const EcoCartFooter: React.FC<ItfEcoCartFooter> = ({ hasAI = false, callback }) => {
    const { locale = '' } = getLocal();
    const t = i18n?.[locale] || i18n.en;
    const { items, coupon } = useEcoCart();
    const [checkoutUrl, setCheckoutUrl] = useState<string>('');

    const handleCheckout = () => {
        const obj: ItfGTM31Cust = { type: 'None', button_name: t.cart_footer_checkout, product_id: '', variant_id: '' };
        items?.forEach((item: ItfEcoCartItem, k: number) => {
            obj.product_id += `${k === 0 ? '' : '_'}${item.productId}`;
            obj.variant_id += `${k === 0 ? '' : '_'}${item.variantId}`;
        });
        const { type, button_name, product_id, variant_id } = obj;
        handle_GTM_31({
            type,
            button_name,
            product_id,
            variant_id,
        });
    };

    useEffect(() => {
        let h: number = 0;
        if (typeof window !== 'undefined') {
            const el: HTMLDivElement | null = document.querySelector('.eco-cart-footer');
            if (el) {
                h = el.offsetHeight;
            }
        }
        callback && callback(h);
    }, [coupon]);

    useEffect(() => {
        if (items?.length > 0) {
            let url: string = `https://${locale}.ecoflow.com/cart/`;
            items?.forEach((item: ItfEcoCartItem, i: number) => {
                const { quantity, variantId } = item;
                url += `${i === 0 ? '' : ','}${variantId}:${quantity}`;
            });
            url += `?channel=buy_button`;
            setCheckoutUrl(url);
        }
    }, [items]);

    return (
        <div className="eco-cart-footer" style={{ marginTop: hasAI ? '0px' : 'auto' }}>
            <EcoCartFooterCoupon />
            <div className="eco-cart-footer-total-price">
                <span className="total">{t.cart_footer_total}</span>
                <span className="price">
                    {FormatMoneyLocal(
                        items.reduce((prev: number, cur: ItfEcoCartItem) => {
                            return prev + (cur.price * 100 * (cur.quantity ?? 0)) / 100;
                        }, 0) - Number(coupon?.discountAmount || 0),
                        locale,
                    )}
                </span>
            </div>
            {checkoutUrl && (
                <EcoLink className="eco-cart-footer-checkout" data-btn-id="checkout" href={checkoutUrl} onClick={handleCheckout}>
                    {t.cart_footer_checkout}
                </EcoLink>
            )}
        </div>
    );
};

export default EcoCartFooter;
